export const ADD = "ADD";
export const DELETE = "DELETE";
export const UPDATING_CONTENT = "UPDATING_CONTENT";
export const UPDATING_PRICE = "UPDATING_PRICE";

export default {
  ADD, DELETE, UPDATING_CONTENT, UPDATING_PRICE
};
